import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.286 1.907a1.93 1.93 0 0 0-2-.474L2.853 4.587a1.933 1.933 0 0 0-.08 3.646l3.493 1.334a.62.62 0 0 1 .353.346l1.334 3.5a1.91 1.91 0 0 0 1.806 1.253h.047a1.92 1.92 0 0 0 1.793-1.333l3.154-9.446a1.93 1.93 0 0 0-.467-1.98m-.767 1.56-3.186 9.453a.59.59 0 0 1-.56.413.61.61 0 0 1-.58-.386l-1.334-3.5a1.94 1.94 0 0 0-1.113-1.12l-3.5-1.334a.6.6 0 0 1-.393-.58.59.59 0 0 1 .413-.56L12.72 2.7a.607.607 0 0 1 .8.767"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })